module.exports = __webpack_public_path__ + "img/activity_fail.81de93fa.png";